import { render, staticRenderFns } from "./DownloadJSON.vue?vue&type=template&id=20530f81&scoped=true&"
import script from "./DownloadJSON.vue?vue&type=script&lang=ts&"
export * from "./DownloadJSON.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20530f81",
  null
  
)

export default component.exports